import { render, staticRenderFns } from "./Men_generate.vue?vue&type=template&id=73c28dc4&scoped=true"
import script from "./Men_generate.vue?vue&type=script&lang=js"
export * from "./Men_generate.vue?vue&type=script&lang=js"
import style0 from "./Men_generate.vue?vue&type=style&index=0&id=73c28dc4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73c28dc4",
  null
  
)

export default component.exports